import { useState } from 'react'
import Modal from '../../../../../components/modal/Modal'
import { Icon } from '@iconify/react'
import { post, put } from '../../../../../utils/Api'
import { useGlobalContext } from '../../../../../utils/Context'
import FormLoader from '../../../../../components/loader/FormLoader'

function CreateAggregatorRate({
  setShowCreate,
  fetchRates,
  selectedZoneData,
}: any) {
  const { notify } = useGlobalContext()
  const [loading, setLoading] = useState(false)

  const createRate = async (data: any) => {
    const emptyFields = []
    if (!data.type) emptyFields.push('type')
    if (!data.zone) emptyFields.push('zone')
    if (!data.document) emptyFields.push('document')
    if (!data.min) emptyFields.push('min')
    if (!data.max) emptyFields.push('max')
    if (!data.charge) emptyFields.push('charge')

    if (emptyFields.length > 0) {
      notify(
        'warn',
        `The following fields are required: ${emptyFields.join(', ')}`
      )
      return
    }

    const inputData = {
      type: data.type,
      zone: data.zone,
      document: data.document,
      min: data.min,
      max: data.max,
      charge: data.charge,
    }
    setLoading(true)
    ;(selectedZoneData
      ? put(`zonerates/aggregator/edit-rate/${selectedZoneData._id}`, inputData)
      : post(`zonerates/aggregator/create`, inputData, null)
    )
      .then((result: any) => {
        if (result.status >= 200 && result.status <= 201) {
          notify('success', result.message)
          setShowCreate(false)
          fetchRates()
        } else {
          notify('error', result.message)
        }
        setLoading(false)
      })
      .catch(() => {
        setLoading(false)
      })
  }

  return (
    <Modal>
      <div className='left-modal'>
        <div className='modal-top flex justify-between items-center'>
          <h2>
            {selectedZoneData
              ? 'Edit Aggregator Rate'
              : 'Create Aggregator Rate'}
          </h2>
          <div className='close flex items-center justify-center'>
            <Icon icon='line-md:close' onClick={() => setShowCreate(false)} />
          </div>
        </div>
        <form
          className='form'
          onSubmit={(e) => {
            e.preventDefault()
            const formData = new FormData(e.target as HTMLFormElement)
            const data = Object.fromEntries(formData.entries())
            createRate(data)
          }}
        >
          <div className='input-card'>
            <p>Type</p>
            <select name='type' required defaultValue={selectedZoneData?.type}>
              <option value=''>-Select-</option>
              <option value='domestic'>Domestic</option>
              <option value='export'>Export</option>
              <option value='import'>Import</option>
            </select>
          </div>
          <div className='input-card'>
            <p>Zone</p>
            <input
              type='text'
              name='zone'
              required
              defaultValue={selectedZoneData?.zone}
            />
          </div>
          <div className='input-card'>
            <p>Document</p>
            <select
              name='document'
              required
              defaultValue={selectedZoneData?.document ? 'true' : 'false'}
            >
              <option value=''>-Select-</option>
              <option value='true'>True</option>
              <option value='false'>False</option>
            </select>
          </div>
          <div className='input-card'>
            <p>Min</p>
            <input
              type='number'
              name='min'
              step='0.01'
              required
              defaultValue={selectedZoneData?.min}
            />
          </div>
          <div className='input-card'>
            <p>Max</p>
            <input
              type='number'
              name='max'
              required
              step='0.01'
              defaultValue={selectedZoneData?.max}
            />
          </div>
          <div className='input-card'>
            <p>Charge</p>
            <input
              type='number'
              name='charge'
              required
              defaultValue={selectedZoneData?.charge}
            />
          </div>
          <div className='input-card'>
            <br />
            {loading ? (
              <FormLoader position='center' />
            ) : (
              <button type='submit'>
                {selectedZoneData ? 'Save' : 'Create '}
              </button>
            )}
          </div>
        </form>
      </div>
    </Modal>
  )
}

export default CreateAggregatorRate
